import apiClient from './client';
import type { AccessCodeResponse } from '../../types/auth.types';

export const authApi = {
  async validateAccessCode(code: string): Promise<AccessCodeResponse> {
    try {
      const response = await apiClient.post<AccessCodeResponse>('/api/auth/validate', {
        access_code: code,
      });
      return response.data;
    } catch (error) {
      console.error('Error validating access code:', error);
      throw error;
    }
  },
};
